import type { BoundingBoxString } from '@/features/types';

export const capitalize = <T extends string>(str: T): Capitalize<T> =>
  `${str[0].toUpperCase()}${str.slice(1).toLowerCase()}` as Capitalize<T>;

export const formatToEventString = (txt: string) => {
  let formattedString = txt;

  if (formattedString.match(/\s+/g)) {
    formattedString = formattedString.replace(/\s+/g, '_').toLocaleLowerCase();
  }
  if (formattedString.match(/[-]/g)?.length) {
    formattedString = formattedString.replace(/[-]/g, '_').toLocaleLowerCase();
  }
  if (formattedString.match(/\.?(?=[A-Z])/)) {
    formattedString = formattedString
      .split(/\.?(?=[A-Z])/)
      .join('_')
      .toLocaleLowerCase();
  }
  return formattedString;
};

/**
 * WKT (Well-Known Text) format for bounding box (our bbox return text)
 * to an array of numbers.
 */
export const WKTBBoxToArray = (bbox?: BoundingBoxString): number[] => {
  if (typeof bbox !== 'string') {
    return [];
  }

  return [...bbox.matchAll(/-?\d+\.?\d+/g)].map((i) => parseFloat(i[0]));
};
